module.exports = __webpack_public_path__ + "img/sophieartmann.96e198bd.jpeg";